import React from 'react';
import PropTypes from 'prop-types';
import { components } from '@seaoil/component-lib';
import Navigation from './Navigation';

const { MainLayout } = components;

function LayoutWithNav(props) {
  const { children } = props;

  return (
    <MainLayout nav={Navigation}>
      {children}
    </MainLayout>
  );
}

LayoutWithNav.defaultProps = {
  children: null,
};

LayoutWithNav.propTypes = {
  children: PropTypes.node,
};

export default LayoutWithNav;
